module.exports = __webpack_public_path__ + "static/img/PK.9aeb8e0b.svg";